export default __webpack_public_path__ + "static/media/signUpDiscord.8a23506e.svg";